<template>
  <footer class="border-t border-neutral-200">
    <div
      class="mx-auto max-w-7xl px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-4"
    >
      <p class="text-sm text-neutral-600">
        © {{ currentYear }} {{ name }}. All rights reserved.
      </p>
      <div class="flex items-center gap-4 text-sm text-neutral-600">
        <a
          href="#"
          class="hover:text-neutral-900 hover:underline underline-offset-4 transition"
        >
          Licenses
        </a>
        <a
          href="#top"
          class="inline-flex items-center gap-2 hover:text-neutral-900 hover:underline underline-offset-4 transition"
          @click.prevent="scrollToTop"
        >
          <ArrowUp :size="16" />
          Back to top
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { ArrowUp } from 'lucide-vue-next'

export default {
  name: 'UIUXFooter',
  components: {
    ArrowUp
  },
  props: {
    name: {
      type: String,
      default: 'Your Name'
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

